import { Component, Input, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { SharedService } from '../../_services/shared.service';


@Component({
    selector: 'app-offer-not-available',
    standalone: true,
    imports: [MatCardModule],
    templateUrl: './offer-not-available.component.html',
    styleUrl: './offer-not-available.component.scss'
})
export class OfferNotAvailableComponent implements OnInit {

  @Input()
  _sharedService: SharedService | null = null;

  constructor(public sharedService: SharedService){

  }
  ngOnInit(): void {
    if(this._sharedService){
      this.sharedService = this._sharedService;
    }
  }


}
